import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {},
  divid: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  TabPanel: {
    maxWidth: '768px',
  },
  formContent: {
    margin: theme.spacing(4, 0),
  },
  singleFormContent: {
    display: 'block',
    '& > .MuiGrid-item': {
      marginInlineEnd: 'auto',
    },
  },
  grid: {
    marginBottom: theme.spacing(0),
  },
  typographyStyle: {
    color: 'rgb(171 165 165)',
    marginLeft: '30px',
    marginTop: 'revert',
    [theme.breakpoints.down('md')]: {
      margin: '7px 0px 7px 0px',
    },
  },
  container: {
    color: 'rgb(171 165 165)',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  buttonWrapper: {
    textAlign: 'left',
  },
  require: {
    color: 'red',
    fontSize: '13px',
  },
  destination: {
    marginBottom: theme.spacing(2),
  },
  backdrop: {
    marginTop: theme.spacing(5),
  },
  cir: {
    textAlign: 'center !important',
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(4),
  },
  progress: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  captcha: {
    maxHeight: 60,
    maxWidth: '100%',
    borderRadius: 4,
    marginInlineStart: theme.spacing(1),
    marginTop: theme.spacing(3),
  },
}));
